export default __webpack_public_path__ + "static/media/Manipal.8e6bba66.png";